export enum NotificationStatus {
  Active = "Active",
  Paused = "Paused"
}
